import React, {useState} from 'react';
import './App.css';
import 'antd/dist/antd.css';
import { Layout, Input, Collapse, Row, Col } from 'antd';
import data from '../data';
import logo from './asset/logo-main.png'
import { SearchOutlined } from '@ant-design/icons';


const { Header, Content } = Layout;

const { Panel } = Collapse;
function callback(key) {
  console.log(key);
}
function sep(text){
  const newText = text.split('\n').map((item, i) => {
  console.log(item)
  });
}
function result(search){
  const results1 = data.filter(data => data.kango_easy === search);
  const results2 = data.filter(data => data.e_read === search);
  console.log(results1);
  console.log(results2);
  const resultsList1 = results1.map((result) =>
   <Panel style = {{width : 400, textAlign:'left'}} header={result.kanji}>
     <Row>
      <Col span= {8}> คำอ่าน</Col>
      <Col span= {16}> {result.n_read}</Col>
     </Row>
     <Row>
      <Col span= {8}> ความหมาย</Col>
      <Col span= {16}> {result.word_meaning}</Col>
     </Row>
     <Row>
      <Col span= {8}> รูปประโยค</Col>
      <Col span= {16}> { sep = result.word_usage.split("\n").map((item) => {
        return <div>{item}</div>
      })}</Col>
     </Row>
     <Row>
      <Col span= {8}> ตัวอย่าง</Col>
      <Col span= {16}> { sep = result.word_ex.split("\n").map((item) => {
        return <div>{item}</div>
      })}</Col>
     </Row>
   </Panel>
  );
  const resultsList2 = results2.map((result) =>
  <Panel style = {{width : 400, textAlign:'left'}} header={result.kanji}>
    <Row>
      <Col span= {8}> คำอ่าน</Col>
      <Col span= {16}> {result.n_read}</Col>
     </Row>
    <Row>
     <Col span= {8}> ความหมาย</Col>
     <Col span= {16}> {result.word_meaning}</Col>
    </Row>
    <Row>
     <Col span= {8}> รูปประโยค</Col>
     <Col span= {16}> { sep = result.word_usage.split("\n").map((item) => {
        return <div>{item}</div>
      })}</Col>
     </Row>
     <Row>
      <Col span= {8}> ตัวอย่าง</Col>
      <Col span= {16}> { sep = result.word_ex.split("\n").map((item) => {
        return <div>{item}</div>
      })}</Col>
    </Row>
  </Panel>
 );
  if(search === '')
    return (
      <div>
      </div>
    )
  else 
    return (
      <div>
      <Collapse onChange={callback}>
        {resultsList1}
        {resultsList2}
      </Collapse>
      </div>
    )
}

function SearchingWord(search){
  if(search === '')
    return (
      <h1>和語ー漢語辞典</h1>
    )
  else 
    return (
      <h1>Searching for '{search}'</h1>
    )
}
function App() {
  const [search,setSearch] = useState('')
return (
    <div>
      <Header style={{backgroundColor: "#FFF"}}>
      <a href="https://dict-52c9a.web.app/about">
        <img style={{width: "220px"}} src={logo} alt="Logo"/>
      </a>
      </Header>
      <Content style={{marginTop: 30}}>
      <div className="App">
        <div className="App-header">
        {SearchingWord(search)}
          
          <Input style={{margin : 50, maxWidth : 400, fontSize : 22}} value={search} placeholder="ひらがな・カタカナで検索" onChange={e => setSearch(e.target.value)} suffix={<SearchOutlined />}/>
          
          {result(search)} 

          
      </div>
    </div>
    </Content>
    </div>

  );
}

export default App;
